import React from "react";
import { Select } from "antd";

const SelectOption = ({
  placeholder,
  options = [],
  className = "",
  value,
  onChange,
  ...props
}) => {
  return (
    <div
      className={`
        bg-gray-50 rounded-lg h-9 flex items-center

        focus-visible:border-ring focus-visible:ring-ring/50 flex w-full items-center
        justify-between gap-2 rounded-md border bg-input-background px-3 py-2 text-sm 
        border-purple-200 focus-within:border-purple-500
        ${className}
      `}
    >
      <Select
        placeholder={placeholder}
        variant="borderless"
        options={options}
        value={value}
        onChange={onChange}
        allowClear
        listHeight={options.length * 32}
        className="w-full text-[14px]"
        {...props}
      />
    </div>
  );
};

export default SelectOption;
